// extracted by mini-css-extract-plugin
export default {"brandingsNew":"g0Clb","brandingLogo":"_21WHx","upgrade":"_1t5K3"};